import React, { Component } from 'react'
import PropTypes from 'prop-types'
import PlatinumSubscription from './PlatinumSubscription'
import BookshelfSubscription from './BookshelfSubscription'

class OrderSubscriptionsContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      platinumUser: window.__USER__.platinum || (props.order.deseret_book_order_subscriptions && props.order.deseret_book_order_subscriptions.filter(sub => sub.subscription_plan_id === props.platinumSubscription.id).length > 0),
    }
    this.handlePlatinumAdded = this.handlePlatinumAdded.bind(this)
  }

  handlePlatinumAdded() {
    this.setState(prevState => ({
      platinumUser: !prevState.platinumUser,
    }))
  }

  render() {
    const {
      order, bookshelfSubscription, platinumSubscription, trial, checkoutStep, ...rest
    } = this.props

    return (
      <div>
        <PlatinumSubscription
          order={order}
          platinumSubscription={platinumSubscription}
          checkoutStep={checkoutStep}
          handlePlatinumAdded={this.handlePlatinumAdded}
        />

        {!window.__USER__.plus
          ? <BookshelfSubscription
            order={order}
            bookshelfSubscription={bookshelfSubscription}
            checkoutStep={checkoutStep}
            trial={trial}
            userIsPlatinum={this.state.platinumUser}
          />
          : null }
      </div>

    )
  }
}

OrderSubscriptionsContainer.defaultProps = {
  order: {},
  bookshelfSubscription: {},
  platinumSubscription: {},
  trial: false,
  checkoutStep: '',
  userIsPlatinum: false,
}

OrderSubscriptionsContainer.propTypes = {
  // The order that is being placed
  order: PropTypes.object,
  // The bookself plus mothly subscription plan
  bookshelfSubscription: PropTypes.object,
  // The bookself plus mothly subscription plan
  platinumSubscription: PropTypes.object,
  // If the user has a trial or not
  trial: PropTypes.bool,
  // The step of checkout
  checkoutStep: PropTypes.string,
  // If the user is platinum or has added the platinum sub
  userIsPlatinum: PropTypes.bool,
}

export default OrderSubscriptionsContainer
